// Generated by Claude Code
import { createFileRoute } from '@tanstack/react-router'
import { AuthGuard } from '#components/tools/auth-guard.tsx'
import { NotFoundPage } from '#components/tools/not-found-page.tsx'
import { CompanyLessPath } from '#components/domain/auth/user/shared/company-less-path.tsx'

/** The company-less address the access-request email links to; it opens the company's Access Requests tab. */
export const Route = createFileRoute('/settings_/users')({
  component: () => (
    <AuthGuard navigateToLoginOnFailure={true}>
      <CompanyLessPath fallback={<NotFoundPage />} />
    </AuthGuard>
  ),
})
